var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',[_c('dt',[_c('img',{attrs:{"src":_vm.block?.bgimg,"alt":""}})]),_c('dd',[_c('div',{staticClass:"div_text bz",domProps:{"innerHTML":_vm._s(_vm.block.bz)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }